import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";
import EditService from "../../../../../services/screens/admin/dictionary/radical/EditService";
import { ActionTypes } from "../../../../actionTypes/screens/admin/dictionary/radical/EditActionTypes";
import AsyncActionReducers from "../../../../AsyncActionReducers";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.radical.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveRadicalAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_RADICAL_ASYNC, vo });

            EditService.saveRadical(
                vo,
                response => {
                    dispatch(Actions.saveRadicalSuccess(response));
                },
                error => {
                    dispatch(Actions.saveRadicalFailure(error));
                }
            );
        };
    },

    saveRadicalSuccess: data => ({
        type: ActionTypes.SAVE_RADICAL_SUCCESS,
        parentType: ActionTypes.SAVE_RADICAL_ASYNC,
        data
    }),

    saveRadicalFailure: error => ({
        type: ActionTypes.SAVE_RADICAL_FAILURE,
        parentType: ActionTypes.SAVE_RADICAL_ASYNC,
        error
    }),

    createRadical: () => ({
        type: ActionTypes.CREATE_RADICAL
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    radical: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, radical: data.radicalDetails };
};

const createLettersReducer = (state) => {
    return { ...state, radical: {} };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_RADICAL_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_RADICAL_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_RADICAL_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_RADICAL]: createLettersReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
